import { Controller } from "@hotwired/stimulus";
import tinymce from "tinymce/tinymce";

// Import all required assets so Webpack bundles them
import "tinymce/models/dom";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/code";
import "tinymce/plugins/media";
import "tinymce/plugins/advlist";

// Import CSS
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/content/default/content.min.css";
import "tinymce/skins/ui/oxide/content.min.css";

export default class extends Controller {
  connect() {
    // This runs automatically whenever a [data-controller="tinymce"]
    // element enters the DOM (via full load, Turbo Frame, or Turbo Stream)
    this.teardown(); // Ensure any existing instance is destroyed
    this.initEditor();
  }

  disconnect() {
    this.teardown();
  }

  // Add this method to handle Turbo caching
  prepareForCache() {
    this.teardown();
  }

  teardown() {
    const editor = tinymce.get(this.element.id);
    if (editor) {
      editor.destroy();
    }
  }

  initEditor() {
    tinymce.init({
      target: this.element,
      skin: false,
      content_css: false,
      license_key: "gpl",
      promotion: false,
      branding: false,
      height: 400,
      plugins: "link image media table code lists advlist",
      toolbar:
        "undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media | code",
      // Allow style tags
      extended_valid_elements: "style",
      valid_children: "+body[style]",
      custom_elements: "style",

      // TinyMCE sandboxes iframes by default (sandbox=""), which breaks
      // PowerBI embeds. Exclusion list replaces the defaults, so keep them.
      sandbox_iframes_exclusions: [
        "youtube.com",
        "youtu.be",
        "vimeo.com",
        "player.vimeo.com",
        "open.spotify.com",
        "app.powerbi.com"
      ],

      // Don't strip HTML
      verify_html: false,
      setup: (editor) => {
        editor.on("change", () => {
          editor.save(); // Syncs back to the hidden textarea
        });
      },
    });
  }
}
